/***
 * Check if browser is on Portrait Mode (https://caniuse.com/mdn-css_at-rules_media_orientation).
 * Using `window.innerHeight > window.innerWidth` is incorrect in mobile when the keyboard is showed up.
 */
export const isPortraitOrientation = (): boolean => {
  const { matches } = window.matchMedia('(orientation: portrait)');
  return matches;
};
